// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { AiOnboardingModal_AiSuggestionFormDataFragment, AiOnboardingModal_HouseholdFragment } from '../../../aiOnboarding/AIOnboardingModal/graphql/aiOnboardingModal.generated';
import { CommonAiSuggestionEvidenceFragment, ReferenceAiOnboardingSuggestionFragment } from '../../graphql/aiSuggestions.generated';
import { DispositiveProvisionsPossibleRecipients_HouseholdFragment } from '../../../dispositiveProvisions/DispositiveProvisionsForm/DispositiveProvisionsFormRecipients/graphql/DispositiveProvisionsFormRecipients.generated';
import { gql } from '@apollo/client';
import { AiOnboardingModal_AiSuggestionFormDataFragmentDoc, AiOnboardingModal_HouseholdFragmentDoc } from '../../../aiOnboarding/AIOnboardingModal/graphql/aiOnboardingModal.generated';
import { CommonAiSuggestionEvidenceFragmentDoc, ReferenceAiOnboardingSuggestionFragmentDoc } from '../../graphql/aiSuggestions.generated';
import { DispositiveProvisionsPossibleRecipients_HouseholdFragmentDoc } from '../../../dispositiveProvisions/DispositiveProvisionsForm/DispositiveProvisionsFormRecipients/graphql/DispositiveProvisionsFormRecipients.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DispositiveProvisionsSuggestedRecipientsQueryVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
  hasDeadGrantors: Types.Scalars['Boolean']['input'];
}>;


export type DispositiveProvisionsSuggestedRecipientsQuery = { __typename?: 'Query', aiSuggestions: { __typename?: 'AISuggestionConnection', edges?: Array<{ __typename?: 'AISuggestionEdge', node?: (
        { __typename?: 'AISuggestion', evidence?: Array<(
          { __typename?: 'AISuggestionEvidence' }
          & CommonAiSuggestionEvidenceFragment
        )> | null }
        & AiOnboardingModal_AiSuggestionFormDataFragment
      ) | null } | null> | null }, households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: (
        { __typename?: 'Household' }
        & AiOnboardingModal_HouseholdFragment
        & DispositiveProvisionsPossibleRecipients_HouseholdFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    DispositiveProvisionsSuggestedRecipients: 'DispositiveProvisionsSuggestedRecipients' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const DispositiveProvisionsSuggestedRecipientsDocument = gql`
    query DispositiveProvisionsSuggestedRecipients($householdID: ID!, $hasDeadGrantors: Boolean!) {
  aiSuggestions(
    where: {hasHouseholdWith: [{id: $householdID}], version: 2, acceptanceStatusIsNil: true, kindIn: [ONBOARDING_ENTITY, ONBOARDING_TESTAMENTARY_ENTITY]}
  ) {
    edges {
      node {
        ...AIOnboardingModal_AISuggestionFormData
        evidence {
          ...CommonAISuggestionEvidence
        }
      }
    }
  }
  households(where: {id: $householdID}) {
    edges {
      node {
        ...AIOnboardingModal_Household
        ...DispositiveProvisionsPossibleRecipients_Household
      }
    }
  }
}
    ${AiOnboardingModal_AiSuggestionFormDataFragmentDoc}
${CommonAiSuggestionEvidenceFragmentDoc}
${AiOnboardingModal_HouseholdFragmentDoc}
${DispositiveProvisionsPossibleRecipients_HouseholdFragmentDoc}`;

/**
 * __useDispositiveProvisionsSuggestedRecipientsQuery__
 *
 * To run a query within a React component, call `useDispositiveProvisionsSuggestedRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDispositiveProvisionsSuggestedRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDispositiveProvisionsSuggestedRecipientsQuery({
 *   variables: {
 *      householdID: // value for 'householdID'
 *      hasDeadGrantors: // value for 'hasDeadGrantors'
 *   },
 * });
 */
export function useDispositiveProvisionsSuggestedRecipientsQuery(baseOptions: Apollo.QueryHookOptions<DispositiveProvisionsSuggestedRecipientsQuery, DispositiveProvisionsSuggestedRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DispositiveProvisionsSuggestedRecipientsQuery, DispositiveProvisionsSuggestedRecipientsQueryVariables>(DispositiveProvisionsSuggestedRecipientsDocument, withFetchPolicyContext(options));
      }
export function useDispositiveProvisionsSuggestedRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DispositiveProvisionsSuggestedRecipientsQuery, DispositiveProvisionsSuggestedRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DispositiveProvisionsSuggestedRecipientsQuery, DispositiveProvisionsSuggestedRecipientsQueryVariables>(DispositiveProvisionsSuggestedRecipientsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useDispositiveProvisionsSuggestedRecipientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DispositiveProvisionsSuggestedRecipientsQuery, DispositiveProvisionsSuggestedRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DispositiveProvisionsSuggestedRecipientsQuery, DispositiveProvisionsSuggestedRecipientsQueryVariables>(DispositiveProvisionsSuggestedRecipientsDocument, withFetchPolicyContext(options));
        }
export type DispositiveProvisionsSuggestedRecipientsQueryHookResult = ReturnType<typeof useDispositiveProvisionsSuggestedRecipientsQuery>;
export type DispositiveProvisionsSuggestedRecipientsLazyQueryHookResult = ReturnType<typeof useDispositiveProvisionsSuggestedRecipientsLazyQuery>;
export type DispositiveProvisionsSuggestedRecipientsSuspenseQueryHookResult = ReturnType<typeof useDispositiveProvisionsSuggestedRecipientsSuspenseQuery>;
export type DispositiveProvisionsSuggestedRecipientsQueryResult = Apollo.QueryResult<DispositiveProvisionsSuggestedRecipientsQuery, DispositiveProvisionsSuggestedRecipientsQueryVariables>;